export const init = () => {
  /* SHOPPING TOOL - BREADCRUMB */

  const fwk = CUBE.Analytics;
  const sep = AnalyticsConstants.separatorST;

  const stType = 'navigation-breadcrumb';

  // CSS Selector : 'breadcrumb menu'
  const breadcrumbSelector = 'ul.breadcrumbs';

  // CLICK on 'breadcrumb menu' link
  $(breadcrumbSelector).on('click.st', 'a', function handler() {
    const position =
      $(this)
        .closest('ul')
        .find('a')
        .index($(this)) + 1;

    fwk.shoppingtool.set(
      `${stType}`,
      `${fwk.utils.getInfoNavFromURLForShoppingTool($(this).attr('href')) +
        sep}level${sep}${position}`
    );
  });
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-breadcrumb.js